import { render, staticRenderFns } from "./PreviewModal.vue?vue&type=template&id=5208c48f&scoped=true"
import script from "./PreviewModal.vue?vue&type=script&lang=js"
export * from "./PreviewModal.vue?vue&type=script&lang=js"
import style0 from "./PreviewModal.vue?vue&type=style&index=0&id=5208c48f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5208c48f",
  null
  
)

export default component.exports